<template>
    <div>
      <invoice-list></invoice-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>